import './selectRangeSlider.scss';
import {useState } from 'react';
import RangeSlider from '@src/components/common/rangeSlider/RangeSlider';
import { TFilterTag } from '@src/types/weddingHallFilter';
import { HALL_FILTER_DEFAULT_MAX_GUARANTEE, HALL_FILTER_DEFAULT_MIN_GUARANTEE } from '@src/utils/weddingHall';


interface ISelectGuaranteeRangeSlider {
	onRangeChange: (min: number, max: number) => void;
	tags: TFilterTag[];
}
const SelectGuaranteeRangeSlider = ({ onRangeChange, tags }: ISelectGuaranteeRangeSlider) => {
  const guaranteeTag =  tags.filter(tag => tag.typeName === 'GUARANTEE');
  const values: number[] = guaranteeTag[0]?.value as number[] || [200, 250];
  const [guaranteeRangeValues, setGuaranteeRangeValues] = useState<number[]>(values);

  const handleRangeChange = (data: number[]) => {
    setGuaranteeRangeValues([data[0], data[1]])
  };


  const handleThumbDragEnd = () =>{
    const [min,max] = guaranteeRangeValues;
    onRangeChange(min, max);
  }

  return (
    <div className='slider-wrap'>
      <p className='range-title-bold bold'>
        {
          guaranteeRangeValues[0] === 350 
          ? '350명 이상' : guaranteeRangeValues[1] === 0 
          ? '0명' :  `${guaranteeRangeValues[0] || 0}명 ~ ${guaranteeRangeValues[1] || 0}명`
        }
			</p>
			<div className='range-slider-wrap-flex'>
				<p>0명</p>
				<RangeSlider 
					className='dual-range-slider'
					min={HALL_FILTER_DEFAULT_MIN_GUARANTEE} 
					max={HALL_FILTER_DEFAULT_MAX_GUARANTEE} 
					step={50}
					value={guaranteeRangeValues}
					onInput={handleRangeChange}
					onThumbDragEnd={handleThumbDragEnd}
				/>
				<p>350명 이상</p>
			</div>
    </div>
  );
};

export default SelectGuaranteeRangeSlider;